
//Property Manager Login 
export const no_values = 'Error: You left necessary fields blank or entered invalid values. ';
export const invalid_login_credentials = 'Error: Invalid user ID or password.';

//Fixed Charges
export const Fixed_charges_error = 'Error: Select one or more fixed charges to perform this action.';
export const selection_error = 'Error: You did not select any items. Select items before you click an action button.';
export const selection_error_alt = 'Error: Select one or more tenants to perform this action.';
export const selection_error_pm = 'Error: Select one or more preventative maintenances to perform this action.';
export const selection_error_wo = 'Error: Select one or more work orders to perform this action.';

//Temperature Adjustments
export const changeLimits_error = 'Error: You left necessary fields blank or entered invalid values.';
export const higherlower_error = 'Error: Maximum Temperature Setting must be greater than Minimum Temperature Setting.';

//Requests
export const req_selection_error_alt = 'Error: Select one or more request to perform this action.';

//Change Password
export const password_expired = 'Error: Your password has expired. Enter your new password below.';
export const passwords_doesnt_match = 'Error: Please type the new password exactly the same in both New Password fields.';
export const passwords_strength = 'Error: The new password does not comply with security requirements.  Use a more secure password or contact your system administrator.';
export const forbidden = 'Error: User Forbidden';
export const password_used_in_history = 'Error: Cannot reuse the same password. Try with new Password.';

//Empty Field validation msg with exclamation mark test
export const no_values_with_mark = 'Error: You left necessary fields blank or entered invalid values. Review and correct any fields with "!" next to them.' 

// Server not responding
export const API_not_responding_msg = 'Error: Cannot connect to Tracer Ensemble. Verify that the Tracer Ensemble service is running and connected to the database, and try again.';

//API Error Messages 
export const API_400_Header = 'Bad Request';
export const API_400_Message = 'The server cannot or will not process the request due to an apparent client error';
export const API_401_Header = 'Unauthorized';
export const API_401_Message = 'Unauthorized Access';
export const API_403_Header = 'Forbidden';
export const API_403_Message = 'You do not have permission to access / on this server';
export const API_404_Header = 'Not Found';
export const API_404_Message = 'The requested resource could not be found';
export const API_500_Header = 'Internal Server Error';
export const API_500_Message = 'Cannot connect to Tracer Ensemble. Verify that the Tracer Ensemble service is running and connected to the database, and try again.';
export const API_502_Header = 'Bad Gateway';
export const API_502_Message = 'Cannot connect to Tracer Ensemble. Verify that the Tracer Ensemble service is running and connected to the database, and try again.';

//Trane Connect User and SC Building credential
export const ErrorCode_10 = 'Error: Please specify a unique building name.  Click Back to view the existing building names.';
export const ErrorCode_25 = 'Error: The Serial Number(s) is being used by another building:';
export const ErrorCode_26 = 'Error: TraneConnect Service is not Initialized';
export const ErrorCode_27 = 'Error: Invalid user ID or password.';



